<section class="onboarding-page">
  <div class="onboarding-hero">
    <div class="hero-copy">
      <img src="assets/branding/logo.png" alt="" class="hero-logo">
      <div>
        <p class="eyebrow">Platform employee</p>
        <h2>Operators</h2>
        <p>Create and maintain the operator organisations that run fleets on the Riya Shuma tracking platform.</p>
      </div>
    </div>
    <div class="hero-actions">
      <button class="hero-action secondary" type="button" (click)="loadOrganisations()">
        <i class="material-icons">refresh</i>
        <span>Refresh</span>
      </button>
      <button class="hero-action" type="button" (click)="startCreate()">
        <i class="material-icons">add_business</i>
        <span>Add operator</span>
      </button>
    </div>
  </div>

  <div class="save-banner error" *ngIf="errorMessage">
    <i class="material-icons">error</i>
    {{ errorMessage }}
  </div>

  <div class="save-banner" *ngIf="successMessage">
    <i class="material-icons">check_circle</i>
    {{ successMessage }}
  </div>

  <div class="onboarding-layout">
    <div class="client-panel">
      <div class="list-header">
        <div>
          <p class="eyebrow">Operators</p>
          <h3>{{ filteredOrganisations.length }} organisations</h3>
        </div>
        <input type="search" placeholder="Search operators" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()">
      </div>

      <form [formGroup]="organisationForm" class="onboarding-form" *ngIf="showForm" (ngSubmit)="saveOrganisation()">
        <div class="form-section">
          <h3>{{ selectedOrganisation ? 'Edit operator' : 'Add operator' }}</h3>
          <div class="form-grid">
            <label>
              Organisation name
              <input formControlName="orgName" type="text" placeholder="Operator transport company">
            </label>
            <label>
              Registration number
              <input formControlName="orgRegistrationNumber" type="text" placeholder="Registration number">
            </label>
            <label>
              Powerlynx Location ID
              <input formControlName="powerlynxLocationID" type="number" min="1" step="1" placeholder="9">
              <small class="field-help">Used to map Powerlynx hotspot sessions to this operator. This is the session locationID from Powerlynx.</small>
              <small class="field-error" *ngIf="organisationForm.get('powerlynxLocationID')?.invalid && organisationForm.get('powerlynxLocationID')?.touched">
                Enter a positive whole number.
              </small>
            </label>
            <label>
              Operator code <span class="legacy-label">legacy fallback</span>
              <input formControlName="operatorCode" type="text" placeholder="MTS">
              <small class="field-help">Used only for older NAS-pattern data such as MTS_4354.</small>
            </label>
            <label>
              Operator type
              <select formControlName="operatorType" (change)="operatorTypeChanged = true">
                <option value="">Not set</option>
                <option *ngFor="let type of getOperatorTypeOptions()" [value]="type">{{ type.replace('_', ' ') }}</option>
              </select>
              <small class="field-help">Used for type-specific feature access. This does not change the user's operator role.</small>
            </label>
            <label class="wide">
              Logo URL
              <input formControlName="orgLogo" type="url" placeholder="https://example.co.za/logo.png">
            </label>
            <label>
              Status
              <select formControlName="statusID">
                <option *ngFor="let status of statuses" [ngValue]="status.statusID">
                  {{ status.statusName || ('Status ' + status.statusID) }}
                </option>
              </select>
            </label>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn btn-secondary" type="button" (click)="cancelForm()">Cancel</button>
          <button class="btn btn-primary" type="submit" [disabled]="organisationForm.invalid || isSaving">
            <i class="material-icons">save</i>
            {{ isSaving ? 'Saving...' : 'Save operator' }}
          </button>
        </div>
      </form>

      <div class="client-grid" *ngIf="filteredOrganisations.length > 0">
        <article class="client-card" *ngFor="let organisation of filteredOrganisations">
          <img [src]="organisation.orgLogo || organisation.organisationLogo || 'assets/branding/logo.png'" alt="" class="client-logo" (error)="useCompanyLogo($event)">
          <div class="client-copy">
            <h3>{{ organisation.orgName || organisation.organisationName || 'Unnamed operator' }}</h3>
            <p>{{ organisation.orgRegistrationNumber || organisation.organisationRegistrationNumber || 'No registration number' }}</p>
            <small>Powerlynx location: {{ getPowerlynxLocationID(organisation) }}</small>
            <small>Legacy operator code: {{ getOperatorCode(organisation) }}</small>
            <small>Operator type: {{ getOperatorTypeLabel(organisation) }}</small>
            <small>Status: {{ getStatusName(organisation) }}</small>
          </div>
          <div class="client-actions">
            <button class="btn-icon" type="button" (click)="editOrganisation(organisation)" title="Edit">
              <i class="material-icons">edit</i>
            </button>
            <button class="btn-icon danger" type="button" (click)="deleteOrganisation(organisation)" title="Delete">
              <i class="material-icons">delete</i>
            </button>
          </div>
        </article>
      </div>

      <div class="empty-state" *ngIf="!isLoading && filteredOrganisations.length === 0">
        <i class="material-icons">business</i>
        <h3>No operators found</h3>
        <p>Add the first operator organisation to begin onboarding.</p>
      </div>
    </div>

    <aside class="readiness-panel">
      <p class="eyebrow">Launch checklist</p>
      <h3>Day-to-day operations path</h3>
      <div class="checklist">
        <div class="checklist-item" *ngFor="let item of checklist">
          <i class="material-icons">{{ item.icon }}</i>
          <span>
            <strong>{{ item.label }}</strong>
            <small>{{ item.detail }}</small>
          </span>
        </div>
      </div>
    </aside>
  </div>
</section>

<app-confirm-dialog
  *ngIf="organisationPendingDelete as organisation"
  title="Delete operator"
  [message]="'Delete ' + (organisation.orgName || organisation.organisationName || 'this operator') + '?'"
  confirmLabel="Delete"
  tone="danger"
  (confirmed)="confirmDeleteOrganisation()"
  (cancelled)="cancelDeleteOrganisation()">
</app-confirm-dialog>
